"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubsequentRequestCreationParameters = exports.isOriginalRequestCreationParameters = exports.isPaymentNetworkId = void 0;
const ExtensionTypes = require("./extension-types");
/**
 * Types a value like ExtensionType into a paymentNetworkID enum element if possible
 * @param value Example: ExtensionTypes.PAYMENT_NETWORK_ID.ERC20_PROXY_CONTRACT
 */
function isPaymentNetworkId(value) {
    return Object.values(ExtensionTypes.PAYMENT_NETWORK_ID).includes(value);
}
exports.isPaymentNetworkId = isPaymentNetworkId;
/**
 * Types the creation parameters as IOriginalRequestCreationParameters if it satisfies the condition
 * @param parameters to test
 */
const isOriginalRequestCreationParameters = (parameters) => {
    return Object.keys(parameters).includes('expectedFlowRate');
};
exports.isOriginalRequestCreationParameters = isOriginalRequestCreationParameters;
/**
 * Types the creation parameters as ISubsequentRequestCreationParameters if it satisfies the condition
 * @param parameters to test
 */
const isSubsequentRequestCreationParameters = (parameters) => {
    return Object.keys(parameters).includes('originalRequestId');
};
exports.isSubsequentRequestCreationParameters = isSubsequentRequestCreationParameters;
